import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import  CertPaymentModel  from "../../models/certpayment";

import BCamInput from "../../helpers/bcam-input";


class CertCameraUploadModal  extends Component {
    constructor() {
        super();
    
        this.state = {
          modalIsOpen: false,
          model:{
            CertReqId:null,
            Base64File:null
          }
          
        };
    
        this.openModal = this.openModal.bind(this);
       
        this.closeModal = this.closeModal.bind(this);
        this.submit=this.submit.bind(this);
        //this.refreshModel= this.refreshModel.bind(this);
        this.updateImage=this.updateImage.bind(this);
      }
    
      openModal(id) {
        const {model}=this.state;
        model.CertReqId=id;
        model.Base64File=[];
        this.setState({modalIsOpen: true,model:model});
      }
      updateImage(image) {
        
        let {model}=this.state;
        model.Base64File = image;
        
        this.setState({
          model:model
        })
      }
    
     
      closeModal() {
        this.setState({modalIsOpen: false});
        
      }

      submit(){
        const {model}=this.state;  
        this.props.submitCamHandler(model);
        this.closeModal();
      }
    
      
    
      render() {
        const {model} = this.state;
        return (
           <Modal style={{opacity:1}} show={this.state.modalIsOpen} onHide={this.closeModal} centered size="md" aria-labelledby="contained-modal-title-vcenter" >
 
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                   ارسال تصویر
                </Modal.Title>
            </Modal.Header>    
            <Modal.Body>
              
              <center>
                <BCamInput width={300} height={300} onChange={this.updateImage} value={model.Base64File}></BCamInput>
              </center>
                
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>
                انصراف
              </Button>
              <Button variant="primary" onClick={this.submit}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }
}

 
export default CertCameraUploadModal;